import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { cn } from "@utils/tailwindMerge";

type ThemeToggleProps = {
  /** Segue o estado do side menu para casar com os demais botoes da barra. */
  expanded: boolean;
};

export function ThemeToggle({ expanded }: ThemeToggleProps) {
  const { resolvedTheme, setTheme } = useTheme();

  // Enquanto o next-themes nao resolve o tema, renderiza um placeholder do
  // mesmo tamanho para o botao nao "pular" nem piscar o icone errado.
  if (!resolvedTheme) {
    return (
      <div
        className={cn("w-full", expanded ? "h-14" : "h-16")}
        aria-hidden="true"
      />
    );
  }

  const isDark = resolvedTheme === "dark";
  const label = isDark ? "Light mode" : "Dark mode";
  const Icon = isDark ? Sun : Moon;

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      aria-pressed={isDark}
      className={cn(
        "flex items-center gap-3 rounded-full transition-colors hover:bg-[#1A2425]",
        expanded ? "px-4 py-4 w-full" : "h-16 w-full flex-col justify-center"
      )}
      onClick={() => setTheme(isDark ? "light" : "dark")}
    >
      {expanded ? (
        <>
          <Icon className="w-6 h-6 flex-shrink-0 text-[#DCE3E4]" />
          <span className="text-sm font-medium text-[#DCE3E4] whitespace-nowrap">
            {label}
          </span>
        </>
      ) : (
        <div className="flex items-center justify-center w-14 h-14">
          <Icon className="w-6 h-6 text-[#DCE3E4]" />
        </div>
      )}
    </button>
  );
}
